module.exports = __webpack_public_path__ + "img/bn(3).520b5268.png";